module.exports = __webpack_public_path__ + "img/eamc.a60a532b.jpg";